import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import consts from '@/consts'

let routes = []
import routes_def from './default.js'
if(!['intuit.shipments', 'prometheus.portal.geotab'].includes(process.env.VUE_APP_PACKAGE)) {
routes.push(...routes_def)
}
//geotab
import routes_prometheus_geotab from './prometheus.portal.geotab.js'
routes.push(...routes_prometheus_geotab)

//shipments
import routes_intuit_shipments from './intuit.shipments.js'
routes.push(...routes_intuit_shipments)

//intuit
import routes_intuit_portal from './intuit.portal.js'
routes.push(...routes_intuit_portal)
import routes_intuit_admin from './intuit.admin.js'
routes.push(...routes_intuit_admin)

//prometheus
import routes_prometheus_portal from './prometheus.portal.js'
routes.push(...routes_prometheus_portal)
import routes_prometheus_admin from './prometheus.admin.js'
routes.push(...routes_prometheus_admin)

//for development
import routes_for_development from './for-development.js'
routes.push(...routes_for_development)

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: '',
            meta: {
                mainRouteName: '',
                parentRouteName: '',
                layers: consts.defaultSettingsLayers,
            },
            components: {
                default: () => import('@/components/_base/EmptyRouteComponent.vue'),
            },
            children: routes,
        },
        {//if route not found !!!
            path: '/:pathMatch(.*)*',
            name: 'null',
            meta: {
                mainRouteName: '',
                parentRouteName: '',
                layers: consts.defaultSettingsLayers,
            },
        },
    ]
})

router.beforeEach(async (to, from) => {
    console.log('beforeEach', to.name/*, from?.name*/)
    store.commit('setShowFilterDropdownMenu', false)

    let isLimited = store.getters.isLimitedUser
    let isDealer = store.getters.isDealer
    let isGuest = store.getters.isGuest
    if (isGuest && !to.meta.isGuest) {
        return {name: 'Login'}
    } else
    if(isLimited && !isDealer && !to.meta?.isLimited) {
        return  false;
    } else
    if (consts.authGuestRoutes.includes(to.name) && !isGuest) {
        return consts.default_route
    } else
    if (['','null'].includes(to.name) && to.path !== consts.default_route) {
        return consts.default_route
    } else
    if (to?.meta?.blockingRoutesTransitionFromOutside && !from?.name) {
        let matched = [...to.matched].filter(r => !r?.meta?.blockingRoutesTransitionFromOutside)
        matched.reverse().shift()
        return matched[0] ? {name: matched[0]?.name, params: to.params} : consts.default_route
    } else
    if (to.params?.pathMatch) {
        let parentRoute = to.matched.find(m => m.name)
        return parentRoute ? {name: parentRoute.name} : consts.default_route
    }
});
router.afterEach(async (to, from, failure) => {
    if(!failure) {
        // if (to?.meta?.mainRouteName !== from?.meta?.mainRouteName) {
        //     store.dispatch('setShowMainList', !!to?.meta?.list)
        // }
        if(store.getters.getReloadRequired && !to?.meta?.blockingRoutesTransitionFromOutside) {
            window.location.reload();
        }
    }
});

export default router
